<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Process Tab" />
    <!-- Page Contents -->
    <sui-page-contents>
      <sui-process-tab
        ref="processtab"
        class="my-processtab"
        :tab-items="tabItems"
        :default-tab-index="defaultTabIndex"
        :set-current-tab-component="setCurrentTabComponent"
        @component-changed="onComponentChanged"        
      >
        <container ref="target" :is="currentTabComponent" @component-mounted="onComponentChanged" />
      </sui-process-tab>
    </sui-page-contents>
  </sui-page>
</template>

<script>
// 탭 컴포넌트
import t02 from './components/tab02.vue';
import t03 from './components/tab03.vue';

// 페이지 컴포넌트
const PGE_CMU_00001 = utils.getPageComponentById('PGE_CMU_00001');
const PGE_CMU_00002 = utils.getPageComponentById('PGE_CMU_00002');

export default {
  name: 'ProcessTabSample', // eslint-disable-line vue/name-property-casing
  components: {
    PGE_CMU_00001,
    PGE_CMU_00002,
    t02,
    t03,
  },
  data() {
    return {
      // Tab
      defaultTabIndex: 0,
      tabItems: [        
        {
          title: 'processtab2',
          component: 't02',
        },
        {
          title: 'processtab1',
          component: 'PGE_CMU_00001',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab4',
          component: 'PGE_CMU_00002',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
        {
          title: 'processtab3',
          component: 't03',
        },
      ],
      currentTabComponent: 't02',
    };
  },
  methods: {
    setCurrentTabComponent(component) {      
      this.currentTabComponent = component;
    },
    onComponentChanged(pageId) {
      // if (this.$refs.target && this.$refs.target) { // refs 가 있는 경우에 API 호출
      // 컴포넌트가 로컬인 경우에는 component-changed 이벤트에서 처리 가능하나, 페이지인 경우에는 component-mounted 이벤트에서 처리 해야 한다.
      // 컴포넌트가 로컬인 경우에는 component-mounted 이벤트가 호출되지 않고, 
      // 컴포넌트가 페이지인 경우에는 component-changed 이벤트 에서는 refs 접근이 불가능 하기 때문에 API 중복 호출이 되는 경우는 없음
      console.warn(`component changed: ${pageId}`);
      // }
    },
  },
};
</script>

<style scoped>
</style>
